import { LocalizedMinorHighlight } from '@mews-commander/ui';
import { Divider, Grid, Stack } from '@optimus-web/core';

export const PlatformProfileDetailsSectionItem = ({ children }: React.PropsWithChildren<{}>) => (
    <Stack distribution="stretch" vertical spacing="200">
        <Grid columnGap="100" templateColumns="minmax(20%, min-content) 1fr">
            {children}
        </Grid>
        <Divider />
    </Stack>
);

export const PlatformProfileDetailsSection = ({
    children,
    textKey,
}: React.PropsWithChildren<{ textKey: Mews.TextKey }>) => (
    <Stack vertical spacing="200">
        <LocalizedMinorHighlight textKey={textKey} />
        <Divider />
        {children}
    </Stack>
);
